// This file is auto-generated during build. Do not edit.

export interface AFHConfig {
  VITE_CDN_URL: string;
  VITE_CDN_ID: string;
  VITE_JAMS_BACKEND_URL: string;
  VITE_JAMS_FRONTEND_URL: string;
  VITE_JUE_API_BASE_URL: string;
  VITE_DESCRIPTION_API_URL: string;
}

export const config: AFHConfig = {
  VITE_CDN_URL: "https://d1uk0lzwvlv9i9.cloudfront.net",
  VITE_CDN_ID: "E3R5CF6S70BJPT",
  VITE_JAMS_BACKEND_URL: "https://u4mchhy7h3.execute-api.us-west-2.amazonaws.com/qa",
  VITE_JAMS_FRONTEND_URL: "https://jams.admin.qa.sodasoft.io",
  VITE_JUE_API_BASE_URL: "https://49o5mfj6gb.execute-api.us-west-2.amazonaws.com/prod",
  VITE_DESCRIPTION_API_URL: "https://m87z97eu3h.execute-api.us-west-2.amazonaws.com/qa",
};
